import {
  Check as CheckIcon,
  Warning as WarningIcon,
} from '@mui/icons-material';
import moment from 'moment';
import React, { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { OrderStatusLabel, Timer } from 'components';
import {
  CancelStatusDetails,
  OrderStatus,
  RequisitesVerificationStatus,
} from 'enums';
import { TranslationNamespace } from 'i18n';
import { PayinOrder } from 'types';

type Props = {
  order: PayinOrder;
  compact?: boolean;
};

export const VerificationOrderStatusLabel: React.FC<Props> = ({
  order,
  compact,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.requisites.verification_status',
  });

  const verificationSuccess = useMemo(
    () =>
      order.status === OrderStatus.Cancelled &&
      order.statusDetails ===
        CancelStatusDetails.CancelledRequisitesVerificationOrder,
    [order],
  );
  const verificationInProgress = useMemo(
    () => order.status === OrderStatus.CustomerConfirm,
    [order],
  );

  return (
    <div className="tw-flex tw-items-center tw-space-x-2">
      {verificationSuccess ? (
        <Fragment>
          {!compact && <CheckIcon color="success" />}
          <span>{t(RequisitesVerificationStatus.Success)}</span>
        </Fragment>
      ) : verificationInProgress ? (
        <Fragment>
          {!compact && (
            <Timer endTime={moment(order.statusTimeoutAt).toDate()} />
          )}
          <span>{t(RequisitesVerificationStatus.Active)}</span>
        </Fragment>
      ) : (
        <Fragment>
          {!compact && <WarningIcon color="error" />}
          <OrderStatusLabel status={order.status} />
        </Fragment>
      )}
    </div>
  );
};
